// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l6vK{display:flex;flex-direction:column;gap:40px;padding-right:32px;position:relative;width:100%}.wYsl,.L0Nm{display:flex;justify-content:center}.USXz{--s:20px;height:20px;height:var(--s);width:20px;width:var(--s)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionPreview": "l6vK",
	"actionPreviewFooter": "wYsl",
	"actionPreviewHeader": "L0Nm",
	"actionPreviewFooterIcon": "USXz"
};
module.exports = ___CSS_LOADER_EXPORT___;
